import {z} from "zod";

export const UnlockedSongLessonsSchema = z.object({
  title: z.string(),
  bonusContentText: z.string(),
  unlockedSongLessons: z.array(z.object({
    lessonId: z.number(),
    thumbnailUrl: z.string(),
    name: z.string(),
    difficultyIdentifier: z.union([z.literal("rookie"), z.literal("intermediate"), z.literal("advanced")]),
    difficultyName: z.string(),
    hasVideo: z.boolean(),
    artistName: z.string(),
    isFavorited: z.boolean(),
    quantityStars: z.number(),
  })),
});

export type UnlockedSongLessonsResponse = z.infer<typeof UnlockedSongLessonsSchema>;